import { render, staticRenderFns } from "./SwitchEditModeButtonParts.vue?vue&type=template&id=2026e730&scoped=true"
import script from "./SwitchEditModeButtonParts.vue?vue&type=script&lang=ts"
export * from "./SwitchEditModeButtonParts.vue?vue&type=script&lang=ts"
import style0 from "./SwitchEditModeButtonParts.vue?vue&type=style&index=0&id=2026e730&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2026e730",
  null
  
)

export default component.exports